import React, { FC } from 'react';
import { Box, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { ScrollBox } from 'common/components';
import { RouteBackground } from 'components';
import messages from 'modules/permissions/messages/messages';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '100%',
  },
  body: {
    flex: 1,
    minHeight: 0,
    width: '100%',
  },
  contentWrapper: {
    flex: 1,
    height: '100%',
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      minWidth: 'auto',
    },
  },
}));

interface IPermissionsContainer {
  className?: string;
  title?: string;
  children: JSX.Element;
}

const PermissionsContainer: FC<IPermissionsContainer> = ({ className, children, title }) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <RouteBackground hasMobilePadding>
      <ScrollBox suppressScrollY>
        <Box overflow="hidden" height="100%" minWidth={650}>
          <Grid container spacing={2} direction="column" className={`${classes.root} ${className}`}>
            <Grid item container spacing={1} justifyContent="space-between">
              <Grid item>
                <Box display="flex" alignItems="center">
                  <Typography variant="h2">
                    {title || intl.formatMessage(messages.permissions)}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Grid item className={classes.body}>
              <Box display="flex" style={{ width: '100%', height: '100%' }}>
                <Box className={`${classes.contentWrapper}`}>{children}</Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </ScrollBox>
    </RouteBackground>
  );
};

export default PermissionsContainer;
